// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/landing_page_templates_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPageTemplatesData } from "./constants";
import type { EngagementLandingPageTemplatesDataParams, EngagementLandingPageTemplatesDataResult } from "./types";
import { isEngagementLandingPageTemplatesDataResult } from "./validators";

export const getDataTableEngagementLandingPageTemplatesData = reactQueryTableFetcherAdapter(
  engagementLandingPageTemplatesData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementLandingPageTemplatesDataParams
  ): Promise<EngagementLandingPageTemplatesDataResult> => {
    return fetch(
      "/engagement/landing_page_templates_data",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementLandingPageTemplatesDataResult
);
